import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all languages
export const getLanguages = async () => {
  try {
    const response = await api.get(`${API_URL}/languages`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); 
  }
};

// Add a new language
export const addLanguage = async (language) => {
  try {
    const response = await api.post(`${API_URL}/languages`, language);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); 
  }
};

// Update a language
export const updateLanguage = async (id, language) => {
  try {
    const response = await api.put(`${API_URL}/languages/${id}`, language);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); 
  }
};

// Delete a language
export const deleteLanguage = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/languages/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); 
  }
};
